export default __webpack_public_path__ + "static/media/yard.830f7baf.png";